import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let HospIndex = class HospIndex extends Vue {
};
HospIndex = __decorate([
    Component({
        name: 'HospitalIndex'
    })
], HospIndex);
export default HospIndex;
;
